import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { FavouritesUserReplacementResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';
import { getAuthenticationConfig } from '../../utils/getAuthenticationConfig';

export const postUserReplacement = async (userId: string) => {
  const path = endpointReplace({ ':siteType': SiteTypes.FAVOURITES }, Endpoints.PostUserReplacement);
  const authentication = await getAuthenticationConfig();

  const response = await network.post<FavouritesUserReplacementResponse>(
    path,
    {
      userId: userId,
      userSource: 'irw',
    },
    authentication,
  );

  return response.data;
};
